import React from 'react';
import {License} from "./license";

const CustomAfterSection = () => {
  return <>
    <License />
  </>
};

export default CustomAfterSection;
